<template>
    <div class="step-box">
        <div class="settlement">
            <div class="money">
                <span>共计</span>
                <span class="text-primary">{{ info.total }}</span>个&nbsp;
                <span>|</span>
                <span>异常</span>
                <span class="text-danger">{{ errMembers.length }}</span>个
            </div>
            <div class="pro-handlers">
                <el-button
                    type="primary"
                    size="mini"
                    @click="queryResult"
                    :disabled="members.length === 0 || errMembers.length > 0"
                    style="margin-right: 10px;"
                    >确认
                </el-button>
                <el-button
                    type="default"
                    @click="
                        goPage(
                            `/index/project/batch/step1`
                        )
                    "
                    size="mini"
                    >返回
                </el-button>
            </div>
        </div>

        <div class="table">
            <el-table
                :data="curData"
                ref="table"
                :border="true"
                style="width: 100%;"
                :stripe="true"
            >
                <el-table-column
                    prop="name"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="项目名称"
                >
                </el-table-column>
                <el-table-column
                    prop="service_id"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="服务需求编号"
                >
                </el-table-column>
                <el-table-column
                    prop="complete_time"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="预计完成时间"
                >
                </el-table-column>
                <el-table-column
                    prop="amount"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="预估人数"
                >
                </el-table-column>

                <el-table-column
                    align="center"
                    fixed="right"
                    width="180"
                    label="校验异常"
                >
                    <template slot-scope="scope">
                        <div class="text-danger">{{ scope.row.error_msg }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            v-if="scope.row.error_msg !== ''"
                            @click="onDelete(scope.row.no, scope.row.error_msg)"
                            size="medium"
                            >
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    background
                    :current-page="current"
                    layout="prev, pager, next"
                    :page-size="perPage"
                    @current-change="onPageChange"
                    :total="alldata.length"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step2',
    inject: ['goPage'],
    data () {
        return {
            members: [],
            errMembers: [],
            total_page: 1,
            info: {},
            perPage: 10,
            curData: [],
            current: 1,
            userInfo: {}
        }
    },
    computed: {
        alldata () {
            return [...this.errMembers, ...this.members]
        }
    },
    mounted () {
        let path = this.$route.query.path
        this.resolveExcel(path)
    },
    methods: {
        onPageChange (e) {
            this.current = e
            this.getData(e)
        },
        getData (e) {
            this.curData = this.alldata.slice(
                (e - 1) * this.perPage,
                e * this.perPage
            )
        },
        onDelete (e, err) {
            if (err !== '') {
                let item = this.errMembers.filter(({ no }) => no === e)[0]
                this.errMembers = this.errMembers.filter(({ no }) => no !== e)
                this.getData(this.current)
                this.info.fail--
                this.info.total--
                this.info.fail_money = (
                    this.info.fail_money * 1 -
                    item.money * 1
                ).toFixed(2)
                this.info.service_fee = (
                    this.info.service_fee * 1 -
                    item.service_fee * 1
                ).toFixed(2)
                this.info.total_money = (
                    this.info.total_money * 1 -
                    item.money * 1
                ).toFixed(2)
                this.info.to_pay = (
                    this.info.to_pay * 1 -
                    item.to_pay * 1
                ).toFixed(2)
            }
        },
        resolveExcel (path) {
            this.$http
                .post(
                    '/api/user/project/importprefork',
                    qs.stringify({
                        path
                    })
                )
                .then(res => {
                    if (res.code === 0) {
                        this.errMembers = res.data.errorData
                        this.members = res.data.listData
                        this.curData = [
                            ...this.errMembers,
                            ...this.members
                        ].slice(0, this.perPage)
                        this.info = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        queryResult () {
            if (this.errMembers.length !== 0) {
                this.$message.error('请先移除异常项')
            } else if (this.members.length === 0) {
                this.$message.error('确认成果的服务不能为空')
            } else {
                this.$http
                    .post(
                        '/api/user/project/commitprefork',
                        qs.stringify({
                            id: this.$route.query.id,
                            list: JSON.stringify(this.members)
                        })
                    )
                    .then(res => {
                        if (res.code === 0) {
                            router.replace(
                                `/index/project/batch/step3`
                            )
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/var";
@import "../../assets/style/sub.scss";

.settlement {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 24px;
    font-size: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid $--border-color-extra-light;

    .money {
        span {
            margin-right: 10px;
        }
    }
}

.data-card__box {
    display: flex;
    padding: 23px 24px 18px;

    .data-card {
        flex: 1;
        background-color: $--color-white;
        display: flex;
        align-items: center;
        padding: 0 22px 0 15px;
        border-right: 1px solid $--border-color-extra-light;

        &:nth-child(4) {
            border-right: none;
        }

        .content {
            flex: 1;
            justify-content: space-around;

            .bd {
                height: 20px;
                font-size: 12px;
                margin-bottom: 5px;
                margin-left: 9px;
            }

            .hd {
                font-size: 18px;
                margin-top: 8px;
                margin-left: 20px;
            }
        }

        .icon {
            .svg-icon {
                font-size: 44px;
            }
        }
    }
}
</style>
